import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, ornament } from "./kit";
import type { LabelTemplate } from "./types";

// The SOH GD house style: initials in a gold ring on black. Authored on the
// wine label; the MCC label is the same design scaled by rebottle().
function wine(): CanvasData {
  const b = "wine";
  return doc(b, INK.black, [
    ornament("double-ring", INK.gold, { width: 34, at: [45, 38], anchor: [100, 100] }),
    // Cinzel Decorative capitals are 0.70 em; baseline = ring centre + half of them.
    centred(b, { text: "AJ", font: "cinzel-decorative", size: 11, color: INK.gold, baseline: 42.6, tracking: 0.04 }),
    centred(b, { text: "YOUR NAME", font: "cinzel", size: 4.5, color: INK.gold, baseline: 63.5, tracking: 0.25 }),
    hairline(INK.gold, 45, 68.3, 30),
    centred(b, { text: "Private Cellar · 2026", font: "cormorant", size: 2.6, color: INK.gold, baseline: 74.6, tracking: 0.12 }),
  ]);
}

export const blackGoldMonogram: LabelTemplate = {
  key: "black-gold-monogram",
  name: "Black & gold monogram",
  occasion: "classic",
  style: "Monogram · black and gold",
  description: "Your initials in a gold ring on black — the house style.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
